<div class="waygate-facets-container">
  <ng-container *ngFor="let facet of facets; let i = index">
    <app-waygate-facet [facet]="facet" [index]="i"></app-waygate-facet>
  </ng-container>
</div>
